<div class="work-office-projekte-dokumente work-office-dokumentenmanager-viewer">
  <div class="flex flex-column gap-24">
    <div class="work-card no-padding">
      <div class="table">
        <div class="work-table">
          <div class="work-table-wrapper">
            <table>
              <!-- Caption provides a brief overview of the table content -->
              <caption class="hide">{{ 'DOKUMENTE' | translate }}</caption>

              <thead>
              <tr>
                <work-ui-table-headers
                  (sort)="sort($event)"
                  [hasActionsColumn]="false"
                  [tableHeaderItems]="tableHeaderItems" />
              </tr>
              </thead>
              <tbody>
                @if (dataPaginated) {
                  @for (document of dataPaginated.data; track document.id) {
                    <tr (click)="openDocument(document)"
                        class="work-action-element">
                      <td class="td-padding work-text-no-wrap">
                        <p><b>{{ document.documenttype?.name }}</b></p>
                        <p class="work-text-color-light"><small>{{ document.name }}</small></p>
                        <p>{{ 'DATUM_ZEIT_UHR' | translate: { datetime: document.upload | formatDate:'DD.MM.YYYY, HH:mm' } }}</p>
                      </td>
                    </tr>
                  } @empty {
                    <p class="padding-24">{{ 'DOKUMENTE_KEINE' | translate }}</p>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<work-ui-modal modalId="projektDokumenteViewerModal" #projektDokumenteViewerModal [noBodyPadding]="true">
  <ng-container modal-body>
    @if (activeDocument(); as activeDocument) {
      <work-ui-dokumente-viewer [activeDocument]="activeDocument" [renderPdfViewer]="!!activeDocument" />
    }
  </ng-container>
</work-ui-modal>
